import React from 'react'
import iconPaste from '../svgs/icons.js'



export default function Switch({ui_element_id, param_value, ui_element_svg_id}){
    
    const classes = []
    let fill_style

    if (param_value === 'true') classes.push('switch-true')
    else fill_style = {filter: 'blur(1px)'}
   
    return(
        <div className={'switch'}>
            <div className={'icon ' + classes.join(' ')} style={fill_style}>{iconPaste(ui_element_svg_id)}</div>
        </div>
    )
}